import type { LayoutSections } from '@teemill/modules/app';

export const toolConfig: LayoutSections = {
  announcement: { show: true, height: '40px' },
  header: {
    show: true,
    fixed: true,
    overlay: false,
    width: '100%',
    height: '4rem',
    logo: true,
    logoMaxWidth: '220px',
    centerLogo: false,
    content: true,
  },
  sidebar: {
    show: true,
    fixed: true,
    width: '220px',
  },
  content: {
    show: true,
    head: true,
    width: '100%',
  },
  footer: {
    show: false,
  },
  subFooter: { show: false },
  navBar: false,
};
